import firebase from "firebase/app";
// import firestore from "firebase/firestore";

// import "firebase/firestore";
// import "firebase/auth";

firebase.initializeApp({
  apiKey: "AIzaSyA8exKm3Jq4xQRhCKz62SXeOEAf1VWBaXI",
  authDomain: "poznajtesty-ad2ca.firebaseapp.com",
  databaseURL: "https://poznajtesty-ad2ca.firebaseio.com",
  projectId: "poznajtesty-ad2ca",
  storageBucket: "poznajtesty-ad2ca.appspot.com",
  messagingSenderId: "14333994731",
  appId: "1:14333994731:web:6b71c6fe3b41042c4a80ae"
});
export default firebase;
